export default "__VITE_PUBLIC_ASSET__dcbbfa87__"